import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { ProofOfIdentityCheckbox } from '../../components/proof-of-identity-checkbox.component';
import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import useProveIdentity from './prove-identity.controller';

const ID = 'prove-identity';

const ProveIdentity = (props: { wizard_id: string }) => {
    const viewProps = useProveIdentity(props);

    useWizardModalScreenNavigation({
        onContinue: viewProps.onSubmit,
        continueDisabled: viewProps.submitDisabled
    });

    if (viewProps.isSkipping) {
        return (
            <div
                id={ID}
                className='flex h-full w-full items-center justify-center'>
                <Spinner />
            </div>
        );
    }

    return (
        <div
            id={ID}
            className='flex w-full flex-col gap-3'>
            <div className='flex items-start justify-start self-stretch'>
                <div className='text-foreground-default justify-start text-base font-medium'>
                    <FormattedMessage
                        id='platform.wizard.prove_identity.instructions'
                        description='Instructions shown when configuring proof-of-identity requirements per package type in the platform PUDO wizard'
                        defaultMessage='Configure proof of identity'
                    />
                </div>
            </div>

            {viewProps.showDropOff && (
                <div
                    data-state='Open'
                    className='outline-border-default inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4 outline-1'>
                    <div className='text-foreground-default text-base font-semibold'>{CommonMessage.BUTTONS.DROP_OFF}</div>
                    <ProofOfIdentityCheckbox
                        id={`${ID}-drop-off-require-proof-of-identity`}
                        value={viewProps.dropOffRequireProofOfIdentity}
                        onChange={viewProps.setDropOffRequireProofOfIdentity}
                        type='drop-off'
                    />
                </div>
            )}

            {viewProps.showPickUp && (
                <div
                    data-state='Open'
                    className='outline-border-default inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4 outline-1'>
                    <div className='text-foreground-default text-base font-semibold'>{CommonMessage.BUTTONS.PICK_UP}</div>
                    <ProofOfIdentityCheckbox
                        id={`${ID}-pick-up-require-proof-of-identity`}
                        value={viewProps.pickUpRequireProofOfIdentity}
                        onChange={viewProps.setPickUpRequireProofOfIdentity}
                        type='pick-up'
                    />
                </div>
            )}
        </div>
    );
};

export default ProveIdentity;
